import * as React from 'react';
import { CianNewbuildingChatButton, CianNewbuildingChatButtonContext } from '@cian/newbuilding-chat-component';
import { TButtonSize } from '@cian/ui-kit/button/types';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import { useDispatch, useSelector } from 'react-redux';

import { useChatButtonContextValue } from './hooks';
import { getPlaceType } from './utils';
import { setBuilderChatButtonClicked } from '../../actions/builderChat';
import { useBuilderChat } from '../../hooks/builderChat';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { ChatOnboardingContainer } from '../ChatOnboardingContainer';

interface IBuilderChatButtonContainerProps {
  isHeaderButton?: boolean;
  buttonSize?: TButtonSize;
}

export const BuilderChatButtonContainer: React.FC<IBuilderChatButtonContainerProps> = ({
  isHeaderButton = false,
  buttonSize = 'M',
}) => {
  const isChatEnabled = useSelector(getBuilderChatEnabled);
  const chatButtonContextValue = useChatButtonContextValue();
  const placeType = getPlaceType(isHeaderButton);

  const dispatch = useDispatch();

  const handleButtonClick = React.useCallback(() => {
    dispatch(setBuilderChatButtonClicked());
  }, [dispatch]);

  const { openChat } = useBuilderChat(placeType);

  if (!isChatEnabled) {
    return null;
  }

  const messageButton = (
    <CianNewbuildingChatButtonContext.Provider value={chatButtonContextValue}>
      <CianNewbuildingChatButton
        beforeIcon={<IconCommunicationMessage16 color="icon-main-default" />}
        size={buttonSize}
        theme={isHeaderButton ? 'fill_secondary' : 'fill_white_primary'}
        type="button"
        onClick={handleButtonClick}
        onChatOpen={openChat}
      >
        Написать
      </CianNewbuildingChatButton>
    </CianNewbuildingChatButtonContext.Provider>
  );

  if (isHeaderButton) {
    return messageButton;
  }

  return <ChatOnboardingContainer type="builder">{messageButton}</ChatOnboardingContainer>;
};
